
/* injects from baggage-loader */

'use strict';

import placeholder from '_images/packs/default.png';

import { filter, findIndex } from 'lodash';

export default class StageBookPuzzleController {
    constructor($log, $rootScope, $state, $Forms, $timeout, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$Forms = $Forms;
        this.Dialog = Dialog;

        this.placeholderImg = placeholder;
    
        this.emptyZonesLengthTotal = filter(this.dropzones, value => value === null ).length;
    }    

    $onInit(){
        this.dropzones = [
            this.dropzones[3],
            this.dropzones[0],
            this.dropzones[1],
            this.dropzones[4],
            this.dropzones[5],
            this.dropzones[2]
        ]
    }

    onDrop(event, data, index){
        let formsIndexOf = findIndex(this.forms, ['key', data.key]);
        
        if(!this.isDropValid(data, this.dropzones[index]))
        { 
            if(this.type === 'color'){
                this.Dialog.showAlert('Opa!', 'TEM CERTEZA QUE ESSA FIGURA É DA COR QUE A PÁGINA PEDE? TENTE NOVAMENTE.',true); 
            }
            else if(this.type === 'size'){
                this.Dialog.showAlert('Opa!', 'TEM CERTEZA QUE ESSA FIGURA TEM O TAMANHO QUE A PÁGINA PEDE? TENTE NOVAMENTE.',true);
            }
            else {
                this.Dialog.showAlert('Opa!', 'TEM CERTEZA QUE ESSA FIGURA TEM A FORMA QUE A PÁGINA PEDE? TENTE NOVAMENTE.',true);
            }
            
            return false;
        }
        
        this.$timeout(()=>{
            this.dropzones[index].valid = true;
            // Remove from container forms
            this.forms.splice(formsIndexOf, 1);
        })

        this.emptyZonesLengthTotal = filter(this.dropzones, value => value === null ).length; 

        let emptyZonesLength = filter(this.dropzones, 'valid').length;
        
        if(emptyZonesLength>=5){
            this.$timeout(()=>{
                this.Dialog.showAlert('PARABÉNS!', 'Você completou seu album geométrico.');
            },1000);
            
        }
    }

    onDropFormsContainer(){ }

    onSubmit(){
        let emptyZonesLength = filter(this.dropzones, value => value === null ).length;
        emptyZonesLength ? this.onFail() : this.onSuccess();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/stage-book-puzzle/stage-book-puzzle.controller.js